<template>
  <div class="modal fade" id="sapDocHistoryModal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-exchange mr-5"></i>{{'sap_history' | translate}}</h4>
        </div>
        <div class="modal-body">
          <div v-for="(value,index) in sapdochistory">
            <template v-if="value instanceof Array">
              <template v-if="value[0].sap_idoc_no!==''">
                <strong>{{index|translate}}</strong>
                <br/>
                <ul>
                  <li v-for="(reduction,index) in value">
                    {{"inbound_date"| translate}}: {{reduction.inbound_date}} <br/>
                    {{"outbound_date"|translate}}: {{reduction.outbound_date}} <br/>
                    {{"sap_idoc_no"|translate}}: {{reduction.sap_idoc_no}}
                  </li>
                </ul>
              </template>
            </template>
            <template v-else-if="value.sap_idoc_no!==''">
              <strong>{{index|translate}}</strong>
              <br/>
              <ul>
                <li>
                  {{"inbound_date"| translate}}: {{value.inbound_date}} <br/>
                  {{"outbound_date"|translate}}: {{value.outbound_date}} <br/>
                  {{"sap_idoc_no"|translate}}: {{value.sap_idoc_no}}
                </li>
              </ul>
            </template>
          </div>
        </div>
        <div class="modal-footer">

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: [
      'sapdochistory'
    ]
  }
</script>




// WEBPACK FOOTER //
// src/components/tools/Modals/SapDocHistoryModal.vue